import { Button } from "@light-technology/components";
import { LinkExternal01 } from "@untitledui/icons";

type NewTabLinkProps = {
  link?: string;
  disabled?: boolean;
  className?: string;
};

export function NewTabLink({
  link,
  disabled: callerDisabled = false,
  className,
}: NewTabLinkProps) {
  const disabled = callerDisabled || !link;

  return (
    <Button
      className={className}
      color="tertiary"
      iconLeading={LinkExternal01}
      isDisabled={disabled}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    />
  );
}
